/**
 * Feature flag (client): full-screen error splash vs legacy error boundary UI.
 * Default off. Set NEXT_PUBLIC_CHUNK_LOAD_ERROR_SPLASH=true to enable the splash for all app errors.
 */
export function isChunkLoadErrorSplashEnabled(): boolean {
  return process.env.NEXT_PUBLIC_CHUNK_LOAD_ERROR_SPLASH === 'true';
}

/**
 * Detects Webpack/Next.js chunk load failures (stale tabs after deploy, CDN hiccups, etc.).
 */
export function isChunkLoadError(error: unknown): boolean {
  if (error == null) return false;

  const err = error as Error & { name?: string };
  const name = typeof err.name === 'string' ? err.name : '';
  const message =
    typeof err.message === 'string'
      ? err.message
      : typeof error === 'string'
        ? error
        : '';

  return (
    name === 'ChunkLoadError' ||
    /loading chunk [\w-]+ failed/i.test(message) ||
    /failed to fetch dynamically imported module/i.test(message) ||
    /importing a module script failed/i.test(message) ||
    /failed to load module script/i.test(message)
  );
}
